import { render, staticRenderFns } from "./Mode_aquaculture.vue?vue&type=template&id=05c155e6&scoped=true"
import script from "./Mode_aquaculture.vue?vue&type=script&lang=js"
export * from "./Mode_aquaculture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c155e6",
  null
  
)

export default component.exports